import { FC } from 'react';

import SunshineTag from 'components/_core/SunshineTag';

import { getBadgeColor, getBadgeLabel } from './helpers';
import { Props } from './types';

const DeviceStatusBadge: FC<Props> = ({ device }) => {
  const badgeColor = getBadgeColor(device);
  const badgeLabel = getBadgeLabel(device);

  return (
    <SunshineTag colorScheme={badgeColor} size="sm">
      {badgeLabel}
    </SunshineTag>
  );
};

export default DeviceStatusBadge;
